import { useEffect, useState } from "react";
import { Link, useParams } from "react-router-dom";
import { Ticket } from "lucide-react";
import { api } from "@/lib/api";
import { useApp } from "@/context/AppContext";
import useSeo from "@/lib/useSeo";

export default function PromoPage() {
  const { code } = useParams();
  const { lang } = useApp();
  const [p, setP] = useState(null);
  useEffect(() => {
    api.get(`/promos/${code}`).then((r) => { setP(r.data); localStorage.setItem("ce_promo", r.data.code); }).catch(() => setP(false));
  }, [code]);
  const off = p ? (p.type === "percent" ? `${p.value}%` : `Rp ${p.value.toLocaleString("id-ID")}`) : "";
  useSeo({ title: p ? p.title || p.code : "Promo", description: p ? `${off} off with code ${p.code}` : "" });
  const id = lang === "id";
  if (p === false) return <p className="text-center py-32" data-testid="promo-not-found">{id ? "Promo tidak ditemukan atau sudah berakhir." : "Promotion not found or expired."}</p>;
  if (!p) return <div className="h-[60vh]" />;
  const min = p.min_subtotal ? (p.min_currency === "USD" ? `$${p.min_subtotal}` : `Rp ${Number(p.min_subtotal).toLocaleString("id-ID")}`) : null;
  return (
    <section className="max-w-3xl mx-auto px-6 py-24 text-center space-y-6" data-testid="promo-page">
      <Ticket className="mx-auto text-[#8C4F27]" size={40} strokeWidth={1.2} />
      <h1 className="font-serif text-4xl sm:text-5xl lg:text-6xl" data-testid="promo-page-title">{p.title || "Promo"}</h1>
      <p className="text-2xl">{id ? `Diskon ${off}` : `${off} off`}</p>
      <p className="inline-block border border-dashed border-[#8C4F27] px-6 py-3 font-mono text-2xl tracking-[0.3em] text-[#8C4F27]" data-testid="promo-page-code">{p.code}</p>
      <p className="text-sm text-[#6E6259]">
        {min && (id ? `Minimal belanja ${min}. ` : `Minimum spend ${min}. `)}
        {p.expires_at && (id ? `Berlaku sampai ${p.expires_at.slice(0, 10)}. ` : `Valid until ${p.expires_at.slice(0, 10)}. `)}
        {id ? "Kode otomatis terpasang saat checkout." : "The code is applied automatically at checkout."}
      </p>
      <Link to="/shop" className="inline-block bg-[#3B220C] text-white px-8 py-3 text-sm" data-testid="promo-shop-btn">{id ? "Belanja sekarang" : "Shop now"}</Link>
    </section>
  );
}
